import { useState } from "react"
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/react"
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid"

interface IEnkComboboxProps {
  id: string
  options: string[]
  value?: number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function EnkCombobox(props: IEnkComboboxProps) {
  const { id, options, value, onChange } = props
  const itemIndex = value || -1
  const selectedItem = itemIndex >= 0 && itemIndex < options.length ? options[itemIndex] : ""

  const [selected, setSelected] = useState<string>(selectedItem)

  const handleOnChange = (changed: string) => {
    setSelected(changed)
    if (onChange) {
      onChange({ target: { id, value: changed } } as React.ChangeEvent<HTMLInputElement>)
    }
  }

  return (
    <Listbox key={id} value={selected} onChange={handleOnChange}>
      <div className="relative mt-2">
        <ListboxButton className="relative h-9 w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary sm:text-sm/6">
          <span className="block truncate">{selected}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon aria-hidden="true" className="size-5 text-gray-400" />
          </span>
        </ListboxButton>

        <ListboxOptions
          transition
          className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none data-[closed]:data-[leave]:opacity-0 data-[leave]:transition data-[leave]:duration-100 data-[leave]:ease-in sm:text-sm"
        >
          {options.map((option, index) => (
            <ListboxOption
              key={index}
              value={option}
              className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 data-[focus]:bg-primary data-[focus]:text-white"
            >
              <span className="block truncate font-normal group-data-[selected]:font-semibold">{option}</span>

              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-primary group-data-[focus]:text-white [.group:not([data-selected])_&]:hidden">
                <CheckIcon aria-hidden="true" className="size-5" />
              </span>
            </ListboxOption>
          ))}
        </ListboxOptions>
      </div>
    </Listbox>
  )
}
